class SessionTerminated{

    /**
     *  @class SessionTerminated
     *  @alias module:src/server/com/silkplm/push/SessionTerminated.SessionTerminated
     *
     * */
    constructor(){
        /** @type {string}  */
        this.popupBody = null;
        /** @type {string}  */
        this.popupTitle = null;
        /** @type {module:src/server/com/silkplm/users/Permission.Permission}  */
        this.requiredPermission = null;
        /** @type {number}  */
        this.scope = null;
        /** @type {number}  */
        this.timestamp = null;
        /** @type {string}  */
        this.type = null;
        /** @type {number}  */
        this.uid = null;
    }
}

let metadata = {};
metadata['popupBody'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata['popupTitle'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata['requiredPermission'] = {'remoteType' : 'module:src/server/com/silkplm/users/Permission.Permission', 'jsType' : 'module:src/server/com/silkplm/users/Permission.Permission', 'mapped' : 'false'};

metadata['scope'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};

metadata['timestamp'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};

metadata['type'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata['uid'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.push.SessionTerminated';
metadata.__type_short__ = 'SessionTerminated';

SessionTerminated.prototype.__metadata__ = metadata;

/** @module src/server/com/silkplm/push/SessionTerminated */
export default SessionTerminated

export { SessionTerminated }
